<template>
  <master-layout>
    <BackButton variant="inline" :is-gic="true" @click="backButton" />
    <div class="mb-6 px-[24px] md:px-8 lg:px-[56px] w-full">
      <Selector
        :selectorTitle="conferenceLanguage.title"
        :buttons="conferenceLanguage.conferenceList"
        :selectedValue="selectedConference"
        @button-selected="handleButtonSelected"
      />
    </div>
  </master-layout>
</template>

<script>
import Selector from '@/components/common/Selector.vue';
import BackButton from '@/components/common/BackButton.vue';
import platformMixin from '@/mixins/platformMixin';
import store from '@/store';
import {
  getSelectedConferenceView,
  getCurrentConferenceType,
  setConferenceView,
  getAvailableConferenceViews,
} from '@/utils/conference-type.js';
import { getCurrentLocale } from '@/utils/deviceLocale';

export default {
  mixins: [platformMixin],
  components: {
    Selector,
    BackButton,
  },
  data() {
    return {
      selectedConference: 'Global',
    };
  },
  async ionViewDidEnter() {
    const profile = store.state.profile;
    this.selectedConference = await getCurrentConferenceType(profile.confYear, profile.conferences);
  },
  computed: {
    conferenceLanguage() {
      const profile = store.state.profile;
      const availableViews = getAvailableConferenceViews(profile.confYear, profile.conferences);

      // Map to the format expected by Selector component
      const conferenceList = availableViews.map(view => {
        let nameKey = '';
        if (view.value === 'Global') {
          nameKey = 'copy.homePage.conferenceType.gpc.name';
        } else if (view.value === 'Regional') {
          nameKey = 'copy.homePage.conferenceType.gpcr.name';
        } else if (view.value === 'GIC') {
          nameKey = 'copy.homePage.conferenceType.gic.name';
        }

        return {
          name: nameKey ? this.$t(nameKey) : view.name,
          value: view.value,
          description: '',
        };
      });

      return {
        title: this.$t('copy.homePage.conferenceType.title'),
        conferenceList: conferenceList,
      };
    },
  },
  methods: {
    backButton() {
      if (this.$route.query.from === 'settings') {
        this.$router.push('/profile');
      } else {
        // route check based on selected conf
        const currentView = getSelectedConferenceView(store.state.profile.conferences);
        if (currentView === 'Regional') {
          this.$router.push('/gpcr/home');
        } else if (currentView === 'GIC') {
          this.$router.push('/gic/home');
        } else {
          this.$router.push('/home');
        }
      }
    },
    async handleButtonSelected(selectedConference) {
      this.selectedConference = selectedConference;
      // store selected conf in local storage
      setConferenceView(this.selectedConference, store.state.profile.conferences);
      const locale = await getCurrentLocale(selectedConference);
      this.loading = true;

      // Route based on selected conference type
      if (selectedConference === 'Regional') {
        this.$router.push('/gpcr/home');
      } else if (selectedConference === 'GIC') {
        this.$router.push('/gic/home');
      } else {
        // Default to Global/GPC
        this.$router.push('/home');
      }
      this.$i18n.locale = locale;
      document.querySelector('html').setAttribute('lang', locale);
    },
  },
};
</script>

<style></style>
